var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CIcon',{staticClass:"text-primary d-block mx-auto m-5",attrs:{"name":"cipCircleLoader","size":"custom-size","height":35}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }